export const measurementEnglish = {
  waiting: 'Waiting for bracelet', waitingHelp: 'Measurement starts when the bracelet responds.',
  measuring: 'Measurement in progress', measuringTemperature: 'Measuring temperature',
  keepStill: 'Keep the arm still', result: 'Your result', results: 'Your results',
  resultSource: 'Result from the bracelet', delayed: 'The measurement is taking a little longer',
  error: 'No measurement received', errorHelp: 'Check the connection and try again.',
  cancelled: 'Measurement cancelled', pulse: 'Pulse', bloodPressure: 'Blood pressure', oxygen: 'Oxygen saturation',
  bpm: 'beats/min.', contact: 'Contact', measuringStep: 'Measuring', resultStep: 'Result',
  expectedTime: 'Expected measurement time · about 1 minute', cancel: 'Cancel measurement',
  history: 'View measurement history', again: 'Measure again', retry: 'Try again', missing: 'Missing',
  elapsed: 'Elapsed measurement time', progress: 'Measurement progress',
};
export type MeasurementCopy = typeof measurementEnglish;
export const measurementDanish: MeasurementCopy = {
  waiting: 'Venter på armbånd', waitingHelp: 'Målingen starter, når armbåndet svarer.',
  measuring: 'Måling i gang', measuringTemperature: 'Måler temperatur',
  keepStill: 'Armen skal holdes i ro', result: 'Dit resultat', results: 'Dine resultater',
  resultSource: 'Resultat fra armbåndet', delayed: 'Målingen tager lidt længere',
  error: 'Ingen måling modtaget', errorHelp: 'Kontrollér forbindelsen, og prøv igen.',
  cancelled: "Målevisning lukket", pulse: 'Puls', bloodPressure: 'Blodtryk', oxygen: 'Iltmætning',
  bpm: 'slag/min.', contact: 'Kontakt', measuringStep: 'Måler', resultStep: 'Resultat',
  expectedTime: 'Forventet måletid · ca. 1 minut', cancel: "Luk målevisning",
  history: 'Se målehistorik', again: 'Mål igen', retry: 'Prøv igen', missing: 'Mangler',
  elapsed: 'Forløbet måletid', progress: 'Målingens fremdrift',
};
